<template>
  <div v-if="data && data.address" @click="goToShopDetailPage" class="shop-card-component">
    <div v-if="mode == 'card'">
      <div class="shop-card">
        <div class="left">
          <img :src="data.mainImage" alt="" />
        </div>
        <div class="right">
          <div class="name">{{ data.name }}</div>
          <div class="address">{{ data.address.formattedAddress }}</div>
          <div class="tag">
            <img v-for="item in data.labels.filter(data => (data ? true : false))" :key="item" :src="item" alt="" />
            <div class="distance" v-if="data.labels.filter(data => (data ? true : false)).length <= 4">
              {{ data.distance > 1 ? `${data.distance.toFixed(1)}km` : data.distance*1000 &lt; 100 ? '&lt;100m' : `${(data.distance*1000).toFixed(1)}m` }}
            </div>
          </div>
          <div class="tag" style="margin-top:8px;">
            <p
              style="background: #FFDBA0;color: #7E2E15;font-size: 12px;height: 100%;padding: 0 0.1rem;text-align: center;line-height: 0.32rem;border-radius: 4px;"
            >
              {{
                activityInfo.categories.filter(info => info.uid == data.categoryId).length > 0 &&
                activityInfo.categories.filter(info => info.uid == data.categoryId)[0].name
                  ? activityInfo.categories.filter(info => info.uid == data.categoryId)[0].name
                  : null
              }}
            </p>
            <div class="distance" v-if="data.labels.filter(data => (data ? true : false)).length > 4">
              {{ data.distance > 1 ? `${data.distance.toFixed(1)}km` : data.distance*1000 &lt; 100 ? '&lt;100m' : `${(data.distance*1000).toFixed(1)}m` }}
            </div>
          </div>
        </div>
      </div>
      <Footer class="footer" :footer="{ locationSignIn: data.locationSignIn }" :mainInfo="data" />
    </div>
    <div v-else-if="mode == 'list'" class="shop-list">
      <div class="left">
        <img :src="data.mainImage" alt="" />
      </div>
      <div class="right">
        <div class="name">{{ data.name }}</div>
        <div class="address">{{ data.address.formattedAddress }}</div>
        <div class="tag">
          <img v-for="item in data.labels.filter(data => (data ? true : false))" :key="item" :src="item" alt="" />
          <div class="distance" v-if="data.labels.filter(data => (data ? true : false)).length <= 4">
            {{ data.distance > 1 ? `${data.distance.toFixed(1)}km` : data.distance*1000 &lt; 100 ? '&lt;100m' : `${(data.distance*1000).toFixed(1)}m` }}
          </div>
        </div>
        <div class="tag" style="margin-top:8px;">
          <p
            style="background: #FFDBA0;color: #7E2E15;font-size: 12px;height: 100%;padding: 0 0.1rem;text-align: center;line-height: 0.32rem;border-radius: 4px;"
          >
            {{
              activityInfo.categories.filter(info => info.uid == data.categoryId).length > 0 &&
              activityInfo.categories.filter(info => info.uid == data.categoryId)[0].name
                ? activityInfo.categories.filter(info => info.uid == data.categoryId)[0].name
                : null
            }}
          </p>
          <div class="distance" v-if="data.labels.filter(data => (data ? true : false)).length > 4">
            {{ data.distance > 1 ? `${data.distance.toFixed(1)}km` : data.distance*1000 &lt; 100 ? '&lt;100m' : `${(data.distance*1000).toFixed(1)}m` }}
          </div>
          <div
            style="
            display: inline-block;
            font-size: 12px;
            color: #333;
            margin-left: 10px;
            padding: 0 0.1rem;
            text-align: center;
            line-height: 0.32rem;
            border-radius: 0.09rem;
            background: #eee;
            width: 1.4rem;
            position: relative;
            "
          >
            进入地图 >
            <span
              class="go-to-map-btn"
              style="
              position: absolute;
              width: 1.6rem;
              height: 200%;
              display: inline-block;
              background: transparent;
              left: -0.1rem;
              top: -50%;
            "
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from "../Footer"

export default {
  components: { Footer },
  props: {
    activityInfo: {
      default: null
    },
    userPosition: {
      default: null
    },
    data: {
      require: true,
      default: null
    },
    mode: {
      type: String,
      default: "card"
    },
    focusInMapById: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    goToShopDetailPage(event) {
      console.log("goToShopDetailPage", event.target)
      if (event.target.className === "go-to-map-btn") {
        this.focusInMapById(this.data.id)
      } else {
        this.$router.push({
          path: "shopDetails",
          name: "shopDetails",
          query: {
            shopId: this.data.id,
            id: this.data.activityId
          },
          params: {
            userPosition: this.userPosition
          }
        })
      }
    }
  }
}
</script>

<style scoped="scoped" lang="scss">
.shop-card-component {
  .shop-list {
    width: 100%;
    min-height: 2.4rem;
    background: #ffffff;
    // box-shadow: 0 0.04rem 0.08rem 0 rgba(113, 108, 98, 0.25);
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    .left {
      margin-left: 0.3rem;
      margin-right: 0.2rem;
      padding-top: 0.3rem;
      img {
        width: 1.8rem;
        height: 1.8rem;
        display: block;
        border-radius: 10px;
        display: block;
      }
    }
    .right {
      width: 100%;
      display: flex;
      flex-flow: column nowrap;
      justify-content: flex-start;
      position: relative;
      min-height: 2.4rem;
      padding: 0.3rem 0.2rem 0.3rem 0;
      overflow: hidden;
      .name {
        font-size: 0.34rem;
        color: #333333;
        letter-spacing: 0;
        margin-bottom: 0.1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        // white-space: nowrap;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .tag {
        display: flex;
        flex-flow: row nowrap;
        position: relative;
        height: 0.32rem;
        width: 100%;
        img {
          display: block;
          width: 0.64rem;
          height: 100%;
          margin-right: 0.2rem;
        }
        .distance {
          font-size: 0.26rem;
          color: #333333;
          letter-spacing: 0;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translate(0, -50%);
        }
      }
      .address {
        font-size: 0.26rem;
        color: #666666;
        letter-spacing: 0;
        margin-bottom: 0.2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .shop-card {
    width: 7.1rem;
    min-height: 1.9rem;
    background: #ffffff;
    // box-shadow: 0 4px 8px 0 rgba(113, 108, 98, 0.25);
    border-radius: 0.06rem;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    .left {
      padding: 0.2rem 0.2rem 0;
      display: flex;
      justify-content: center;
      img {
        width: 1.8rem;
        height: 1.8rem;
        display: inline-block;
        border-radius: 10px;
        object-fit: cover;
      }
    }
    .right {
      width: 100%;
      display: flex;
      flex-flow: column nowrap;
      position: relative;
      padding: 0.2rem 0.2rem 0.5rem 0;
      justify-content: flex-start;
      overflow: hidden;
      .name {
        font-size: 0.34rem;
        color: #333333;
        letter-spacing: 0;
        margin-bottom: 0.1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        // white-space: nowrap;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .tag {
        display: flex;
        flex-flow: row nowrap;
        position: relative;
        height: 0.32rem;
        width: 100%;
        img {
          display: block;
          width: 0.64rem;
          height: 100%;
          margin-right: 0.2rem;
        }
        .distance {
          font-size: 0.26rem;
          color: #333333;
          letter-spacing: 0;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translate(0, -50%);
        }
      }
      .address {
        width: 100%;
        font-size: 0.26rem;
        color: #666666;
        letter-spacing: 0;
        margin-bottom: 0.15rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .footer {
    height: 1.37rem;
    width: 100%;
    padding: 0 0.2rem;
    display: flex;
    justify-content: space-around;
  }
}
</style>
